/*jshint unused:false*/
/*global fetch */
/*global console */

// Load Home Video
if (document.querySelector('.page-home .full-header-ctr')){
  const mediaQuery = window.matchMedia('(max-width: 1199px)')
  if (!mediaQuery.matches) {
    let videoElement = document.createElement('video');
    videoElement.setAttribute('autoplay', 'autoplay');
    videoElement.setAttribute('loop', 'loop');
    videoElement.setAttribute('muted', 'muted');
    videoElement.id = 'videoBg'
    let videoSource = document.createElement('source');
    videoSource.setAttribute('type', 'video/mp4');
    videoSource.setAttribute('src', '/themes/ovl/img/2223564_Car_Driving_1280x720.mp4');
    videoElement.appendChild(videoSource);
    document.querySelector('.page-home .full-header-ctr').prepend(videoElement);
    setTimeout(() => {
      document.querySelector('.page-home .full-header-ctr video').muted = true;
      document.querySelector('.page-home .full-header-ctr video').play();
    }, 500);
  }
}
// END Load Home Video

// Price toggles
let allSwitches = [].slice.call(document.querySelectorAll('.price-toggle'));
let priceContainers = [].slice.call(document.querySelectorAll('.deal-price-toggle'));
let priceSwitchForm = document.getElementById('price-switch');
let selected;
allSwitches.forEach((value) => {
  value.addEventListener('change', (val) => {
    (val.composedPath()[0].classList.contains('toggle-personal')) ? selected = 0 : selected = 1;
    toggleSwitches();
    togglePrices();
    updatePrice();
  })
})
let toggleSwitches = () => {
  allSwitches.forEach((v) => {
    (selected === 0) ? v.querySelectorAll('.toggle-personal').forEach((v) => { v.checked = true }) : v.querySelectorAll('.toggle-business').forEach((v) => { v.checked = true });
  })
  document.querySelector("#switch-price-type") ? document.querySelector("#switch-price-type").value = (selected === 0) ? 'Personal' : 'Business' : null;
}
let togglePrices = () => {
  priceContainers.forEach((v) => {
    (selected === 0) ? v.querySelector('.price-personal').classList.add('active') : v.querySelector('.price-personal').classList.remove('active');
    (selected === 1) ? v.querySelector('.price-business').classList.add('active') : v.querySelector('.price-business').classList.remove('active');
  })
}
let updatePrice = () => {
  if (priceSwitchForm){
    let url = priceSwitchForm.getAttribute('action');
    let formData = new FormData(priceSwitchForm);
    fetch(url, {
      method: 'POST',
      processData: false,
      contentType: false,
      body: formData,
      headers: {
        'X-CSRF-TOKEN': document.querySelector("#price-switch [name=_token]").value,
        'X-Requested-With': 'XMLHttpRequest'
      },
    }).then(
        function(response) {
          if (response.status !== 200) {
            console.log('Looks like there was a problem. Status Code: ' + response.status);
            return;
          }
          response.json().then(function(data) {
            document.querySelector("#price-switch [name=_token]").value = data.token;
          });
        }
    ).catch(function(err) {
      console.log('Fetch Error :-S', err);
    });
  }
}
// End price Toggles

// Back to top button
const scrollToTopButton = document.getElementById('back_to_top');
let smoothScrollCapture = (x) => {
  event.preventDefault();
  let id = x.currentTarget.target.getAttribute('href').split("#")[1]
  let el = document.getElementById(id);
  var x = el.getBoundingClientRect().left;
  var y = el.getBoundingClientRect().top;
  smoothScrollFunc(x, y)
}

let smoothScrollFunc = (x, y) => {
  event.preventDefault();
  window.scrollTo({
    top: y,
    left: x,
    behavior: 'smooth'
  });
}

window.addEventListener('DOMContentLoaded', () => {
  scrollToTopButton.addEventListener('click', () => {
    smoothScrollFunc(0, 0);
  })
})

window.addEventListener('scroll', () => {
  let pageHeight = document.body.scrollHeight;
  let currentHeight = window.scrollY;
  (currentHeight > (pageHeight/2)) ? scrollToTopButton.classList.add('active') : scrollToTopButton.classList.remove('active');
})
// End back to top button

// Function to write a cookie
function writeCookie(key, value, days) {
  let date = new Date();
  days = days || 7;
  date.setTime(date.getTime() + (days * 86400000)); // 24 * 60 * 60 * 1000
  // document.cookie = `${key}=${value}; expires=${date.toUTCString()}; path=/; SameSite=None; Secure`;
  document.cookie = `${key}=${value}; expires=${date.toUTCString()}; path=/`;

  console.log(`Cookie set: ${key}=${value}, expires in ${days} days`);
}

// Function to read a cookie
function readCookie(key) {
  const nameEQ = key + "=";
  const ca = document.cookie.split(';');
  for (let i = 0; i < ca.length; i++) {
    let c = ca[i].trim();
    if (c.indexOf(nameEQ) === 0) {
      console.log(`Cookie read: ${key}=${c.substring(nameEQ.length, c.length)}`);
      return c.substring(nameEQ.length, c.length);
    }
  }
  console.log(`Cookie not found: ${key}`);
  return null;
}


/* MOBILE MODALS */
const navContainer = document.querySelector('.nav-container');
const hamburger = document.querySelector('#hamburger');

const modalMobileNav = new tingle.modal({
  footer: false,
  closeMethods: ['escape'],
  cssClass: ['mobile-nav','reversed']
});
modalMobileNav.setContent(document.querySelector('.site-menu').innerHTML);

// Nav modal
const handleToggle = () => {
  hamburger.classList.toggle('active');
  hamburger.classList.toggle('is-active');
  navContainer.classList.toggle('is-active');

  if(hamburger.classList.contains("active")) {
    modalMobileNav.open();
  } else{
    modalMobileNav.close();
  }
}

// Sticky class for navbar & modal
// window.onscroll = function() {stickyNav()};
// let navbar = document.getElementById('navbar');
// let tingleModal = document.querySelector('.tingle-modal');
// let sticky = navbar.offsetTop;
// function stickyNav() {
//   if (!document.body.classList.contains('tingle-enabled')) {
//     if (window.pageYOffset >= sticky) {
//       navbar.classList.add('is-sticky')
//       tingleModal.classList.add('is-sticky')
//       if(document.querySelector('#navbar img')){
//         document.querySelector('#navbar img').src = "/themes/ovl/img/logos/logo.svg";
//       }
//     } else {
//       navbar.classList.remove('is-sticky')
//       tingleModal.classList.remove('is-sticky')
//       if(document.querySelector('.transparent-header img')){
//         document.querySelector('.transparent-header img').src = "/themes/ovl/img/logos/logo.svg";
//       } else if(document.querySelector('#navbar img')){
//         document.querySelector('#navbar img').src = "/themes/ovl/img/logos/logo-green.svg";
//       }
//     }
//   }
// }


const header = document.getElementById('navbar');
const topBarHeight = document.querySelector('.top-bar').clientHeight;
let isSticky = false;

const stickyEnterThreshold = topBarHeight - 3; // Add sticky when above this
const stickyExitThreshold = topBarHeight - 23;  // Remove sticky when below this

// console.log(stickyEnterThreshold)
// console.log(stickyExitThreshold)

window.addEventListener('scroll', () => {
  const y = window.scrollY;

  if (!isSticky && y > stickyEnterThreshold) {
    header.classList.add('is-sticky');
    isSticky = true;
    // console.log('Sticky changed: true');
  } else if (isSticky && y < stickyExitThreshold) {
    header.classList.remove('is-sticky');
    isSticky = false;
    // console.log('Sticky changed: false');
  }
});



hamburger.onclick = () => handleToggle();
hamburger.addEventListener('keyup', (event) => {
  if(event.keyCode === 13 || event.keyCode === 32) {
    handleToggle();
  }
});
/* END MOBILE MODALS */

// Toggle search bar
  document.getElementById('toggle-search') ? document.getElementById('toggle-search').addEventListener('click', () => {
    document.querySelector('.header-search').classList.toggle('active');
    document.querySelector('.search-opener').classList.toggle('active');
  }) : '';

// Toggle loader when searching
  document.querySelector('.search-button') ? [].slice.call(document.querySelectorAll('.search-button')).forEach((value) => {
    value.addEventListener('click', () => {
      document.body.classList.remove('loaded')
    })
  }) : '';


// Toggle class for accordions
function toggleAccordions() {
  let acc = document.getElementsByClassName('mobile-accordion-header');
  for (let i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function(ev) {

      for (let i = 0; i < acc.length; i++) {
        if (acc[i] === this || acc[i].parentElement.parentElement !== this.parentElement.parentElement || this.parentElement.classList.contains('no-close')) {
          continue;
        }
        acc[i].parentElement.classList.remove('active');
      }

      if (!this.parentElement.classList.contains('active') && !this.parentElement.classList.contains('no-scroll')){
        setTimeout(() => { document.documentElement.scrollTop += this.getBoundingClientRect().top; }, 500);
      }
      this.parentElement.classList.toggle("active");

    });
  }
}
toggleAccordions();

//Dropdown Menu Toggle
var showMenu = function(){
    //div inside element contains dropdown menu
    var dropdown = this.parentNode.querySelector('div');
    var menuToggle = this;

    //if it's already active set it not to be
    if(dropdown.classList.contains("active")){
        dropdown.classList.toggle("active");
        menuToggle.classList.toggle("active");
        dropdown.classList.toggle("is-active");
        menuToggle.classList.toggle("is-active");
        return;
    }
    //get current active class
    var activeClass = document.querySelectorAll(".dropdown-menu .active");
    // make it not active
    if(activeClass!=null){
        for(var i=0; i<activeClass.length; i++){
          activeClass[i].classList.toggle("active");
          activeClass[i].classList.toggle("is-active");
        }
    }

    //apply active to the div inside element that contains dropdown menu
    dropdown.classList.toggle("active");
    dropdown.classList.toggle("is-active");
    menuToggle.classList.toggle("active");
    menuToggle.classList.toggle("is-active");
}

var menuDropdown = document.querySelectorAll(".dropdown-menu > a");

for(var i=0; i<menuDropdown.length; i++){
  menuDropdown[i].addEventListener('click', showMenu, false);
}

//faqs
var faqSearch = document.querySelector('.faq-search input');

if(faqSearch !== null){
  faqSearch.addEventListener('keyup', function(e){
    var results = document.getElementById('faq-results');
    if(this.value.length != 0){
      results.classList.add("active");
    } else {
      results.classList.remove("active");
    }
  });
}

//More Options Toggle
var classname = document.querySelectorAll(".more-options");

var moreOptions = function(e) {
	e.preventDefault();
  var element = document.getElementById("vehicle-search");
  element.classList.toggle("active");
  if(element.classList.contains('active')){
    this.innerHTML = 'Hide additional options';
  } else {
    this.innerHTML = 'Show me more options';
  }
};

for (var i = 0; i < classname.length; i++) {
    classname[i].addEventListener('click', moreOptions, false);
}

//Tab Content
function openTab(e, tabName) {
  var i, tabcontent, tablinks;
  tabcontent = document.getElementsByClassName("tab-content");
  tablinks = document.getElementsByClassName("tab");

  //remove active tab
  for (i = 0; i < tabcontent.length; i++) {
    tabcontent[i].className = tabcontent[i].className.replace(" active", "");
  }

  //remove active from button tabs
  for (i = 0; i < tablinks.length; i++) {
    tablinks[i].className = tablinks[i].className.replace(" active", "");
  }
  //add active to tab
  document.getElementById(tabName).className += " active";

  //add active to button tabs
  e.currentTarget.className += " active";
}

//Search for Cars or Vans
function showDesc(el){
  el.style.display = 'none';
  el.parentNode.querySelector('.extra').classList.remove('visuallyhidden');
}

function searchSorter() {
  let searchSorter = document.querySelector('#search-sorter');
  if (searchSorter) {
    searchSorter.addEventListener('change', (e) => {
      const urlParams = new URLSearchParams(window.location.search);
      urlParams.set('order', e.target.value);
      if ((e.target.value === 'price_asc' || e.target.value === 'price_desc') && !window.location.search.includes('initial_profile')) {
        urlParams.set('initial_profile', e.target.dataset.profile);
      }
      window.location.search = urlParams;
    })
  }
}
searchSorter();

const searchButton = true;

// SEARCH SIDEBAR
function setUrlParams(param, value, module) {
  let searchUrl = new URL(window.location.origin + window.location.pathname);
  if (module === 'Search') {
    if (window.location.search.includes('offers=specials')) {
      searchUrl.searchParams.set('offers', 'specials');
    } else if (window.location.search.includes('offers=stock')) {
      searchUrl.searchParams.set('offers', 'stock');
    }
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', document.querySelector('#search-type').value);
  } else if (window.location.pathname === '/car-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'car');
  } else if (window.location.pathname === '/special-offers') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'car');
    searchUrl.searchParams.set('offers', 'specials');
  } else if (window.location.pathname === '/stock') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'car');
    searchUrl.searchParams.set('offers', 'stock');
  } else if (window.location.pathname === '/van-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
  } else if (window.location.pathname === '/van-leasing/special-offers') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
    searchUrl.searchParams.set('offers', 'specials');
  } else if (window.location.pathname === '/van-leasing/stock') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
    searchUrl.searchParams.set('offers', 'stock');
  } else if (window.location.pathname === '/pick-up-leasing') {
    searchUrl = new URL(window.location.origin + '/search');
    searchUrl.searchParams.set('manufacturer_redirect', 'false');
    searchUrl.searchParams.set('search-type', 'van');
    searchUrl.searchParams.append('body_type', 'Pick-up');
  } else {
    (value==='van') ? searchUrl = new URL(window.location.origin + '/van-leasing' + window.location.pathname) : null;
    (value==='car') ? searchUrl = new URL(window.location.origin + (window.location.pathname).replace('/van-leasing', '')) : null;
    searchUrl.searchParams.set('filter', 'true');
  }
  if(param==='type'){
    searchUrl.searchParams.set('search-type', value);
    searchUrl.searchParams.set('make', '');
    searchUrl.searchParams.set('model', '');
    searchUrl.searchParams.delete('van_size');
    searchUrl.searchParams.delete('body_type');
  } else {
    searchUrl.searchParams.set('make', param==='make' ? value : (document.querySelector('.search-aside input[name="make"]:checked') ? document.querySelector('.search-aside input[name="make"]:checked').value : ''));
    searchUrl.searchParams.set('model', param==='model' ? value : (document.querySelector('.search-aside input[name="model"]:checked') ? document.querySelector('.search-aside input[name="model"]:checked').value : ''));
    // param==='make' ? searchUrl.searchParams.set('model', '') : null;

    if(window.location.pathname !== '/pick-up-leasing'){
      searchUrl.searchParams.set('van_size', (param==='van_size') ? value : (document.querySelector('.search-aside input[name="van_size"]:checked') ? document.querySelector('.search-aside input[name="van_size"]:checked').value : ''));
      searchUrl.searchParams.set('body_type', (param==='body_type') ? value : (document.querySelector('.search-aside input[name="body_type"]:checked') ? document.querySelector('.search-aside input[name="body_type"]:checked').value : ''));
    }

    if(param==='make'){
      searchUrl.searchParams.delete('model');
      searchUrl.searchParams.delete('van_size');
      searchUrl.searchParams.delete('body_type');
    }
    if(param==='model'){
      searchUrl.searchParams.delete('van_size');
      searchUrl.searchParams.delete('body_type');
    }
    if(param==='van_size'){
      searchUrl.searchParams.delete('body_type');
    }
    if(param==='body_type'){
      searchUrl.searchParams.delete('van_size');
    }
  }

  let updatedMin = document.querySelector('.search-aside #budget-slider .noUi-handle-lower').getAttribute('data-value');
  let updatedMax = document.querySelector('.search-aside #budget-slider .noUi-handle-upper').getAttribute('data-value');
  if(isNaN(updatedMax) && updatedMin == '0') {
    searchUrl.searchParams.delete('budget');
  } else if(isNaN(updatedMax) && updatedMin != '0') {
    searchUrl.searchParams.set('budget', param==='budget' ? value : (updatedMin + '+'));
  } else{
    searchUrl.searchParams.set('budget', param==='budget' ? value : (updatedMin + '-' + updatedMax));
  }
  searchUrl.searchParams.set('fuel_type', param==='fuel_type' ? value : (document.querySelector('.search-aside input[name="fuel_type"]:checked') ? document.querySelector('.search-aside input[name="fuel_type"]:checked').value : ''));
  searchUrl.searchParams.set('transmission', param==='transmission' ? value : (document.querySelector('.search-aside input[name="transmission"]:checked') ? document.querySelector('.search-aside input[name="transmission"]:checked').value : ''));
  searchUrl.searchParams.set('seats', param==='seats' ? value : (document.querySelector('.search-aside input[name="seats"]:checked') ? document.querySelector('.search-aside input[name="seats"]:checked').value : ''));

  searchUrl.searchParams.set('term', param==='term' ? value : (document.querySelector('.search-filters [name="term"]') ? document.querySelector('.search-filters [name="term"]').value : ''));
  searchUrl.searchParams.set('initial_profile', param==='initial_profile' ? value : (document.querySelector('.search-filters [name="initial_profile"]') ? document.querySelector('.search-filters [name="initial_profile"]').value : ''));
  searchUrl.searchParams.set('mileage', param==='mileage' ? value : (document.querySelector('.search-filters [name="mileage"]') ? document.querySelector('.search-filters [name="mileage"]').value : ''));

  searchUrl.searchParams.set('order', param==='order' ? value : (document.querySelector('.search-filters select[name="order"]') ? document.querySelector('.search-filters select[name="order"]').value : ''));

  window.location.href = searchUrl;
}

// Show Only Filters
function updateSearchToggles() {
  let searchToggles = document.querySelectorAll('.search-form .stock input');
  if (searchToggles) {
    if (!searchButton) {
      searchToggles.forEach(value => {
        value.addEventListener('change', (e) => {
          let searchUrl = new URL(window.location.origin + '/car-leasing');
          let vans = (window.location.pathname.includes('van-leasing') || window.location.search.includes('search-type=van')) ? '/van-leasing' : '';
          (window.location.pathname.includes('van-leasing')) ? searchUrl = new URL(window.location.origin + '/van-leasing') : null;
          (e.target.value === 'stock' && e.target.checked) ? searchUrl = new URL(window.location.origin + vans + '/stock') : null;
          (e.target.value === 'stock' && e.target.checked && e.target.dataset.module === 'Electric.Offers') ? searchUrl = new URL(window.location.origin + '/search?search-type=car&offers=stock&fuel_type=Electric') : null;
          (e.target.value === 'stock' && e.target.checked && e.target.dataset.module === 'Hybrid.Offers') ? searchUrl = new URL(window.location.origin + '/search?search-type=car&offers=stock&fuel_type=Hybrid') : null;
          (e.target.value === 'stock' && e.target.checked && window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=', 'offers=stock')) : null;
          (e.target.value === 'stock' && e.target.checked && window.location.pathname==="/search" && !window.location.search.includes('offers=')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('?', '?offers=stock&')) : null;
          (e.target.value === 'stock' && e.target.checked && window.location.search.includes('offers=&')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=&', 'offers=stock&')) : null;
          (e.target.value === 'stock' && !e.target.checked && window.location.search.includes('offers=stock')) ? searchUrl = new URL(window.location.origin + '/search' + window.location.search.replace('offers=stock', 'offers=')) : null;
          
          window.location.href = searchUrl;
        })
      })
    }
  }
}
// END Show Only Filters

function loadSearchType(){
  if (searchButton){
    document.querySelectorAll('.search-aside input[name="search_type"]').forEach(v => {
      v.addEventListener('change', e => {
        document.querySelectorAll('#make-wrapper input').forEach(v => { v.checked = false })
        document.querySelector('.search-aside #search-type').value = document.querySelector('.search-aside input[name="search_type"]:checked').value;
        let type = document.querySelector('.search-aside #search-type').value;
        loadManufacturersRadio(type);
      })
    })
  }
}

function loadSearchTriggers() {
  // console.log("loadSearchTriggers");
  if (document.querySelector('.search-aside') && document.querySelector('.search-filters')) {

    let selectedMake = document.querySelector('.search-aside input[name="make"]:checked');

    if (searchButton){
      document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
        v.addEventListener('change', e => {
          selectedMake = document.querySelector('.search-aside input[name="make"]:checked');
          document.querySelectorAll('.model-wrapper').forEach(v => { v.innerHTML = ''; v.classList.remove('show'); })
          loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);
          let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
          (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
        })
      })
    }

    if (document.querySelector('.search-aside #search-type')) {

      // Show Models for selected manufacturer
      if (selectedMake) {
        loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);

        let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
        (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
        console.log(".3");
      }

      if(document.querySelector('.search-aside #body_type-wrapper')){
        loadBodyTypesRadio(document.querySelector('.search-aside #search-type').value);
      }
      if(document.querySelector('.search-aside #fuel_type-wrapper')){
        loadFuelTypesRadio(document.querySelector('.search-aside #search-type').value);
      }
      if(document.querySelector('.search-aside #transmission-wrapper')){
        loadTransmissionTypesRadio(document.querySelector('.search-aside #search-type').value);
      }

      (document.querySelector('.button-clear')) ? null : document.querySelector('.clear-filters').classList.add('visuallyhidden');

      if(!searchButton) {
        document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
          v.addEventListener('change', e => {
            
            document.querySelector('.search-aside .model-wrapper [name="model"]:checked') ? document.querySelector('.search-aside .model-wrapper.show [name="model"]:checked').checked = false : null;
            setUrlParams('make', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside [name="model"]').forEach(v => {
          v.addEventListener('change', e => {
            
            setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside [name="van_size"]').forEach(v => {
          v.addEventListener('change', e => {
            
            //remove bodytype
            document.querySelector('.search-aside [name="body_type"]:checked') ? document.querySelector('.search-aside [name="body_type"]:checked').checked = false : null;
            setUrlParams('van_size', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside [name="body_type"]').forEach(v => {
          v.addEventListener('change', e => {
            
            //remove van size
            document.querySelector('.search-aside [name="van_size"]:checked') ? document.querySelector('.search-aside [name="van_size"]:checked').checked = false : null;
            setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
            // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
          })
        })
        // document.querySelectorAll('.search-aside input[name="budget"]').forEach(v => {
        //   v.addEventListener('change', e => {
        //     
        //     setUrlParams('budget', e.target.value, document.querySelector('.search-content').dataset.module);
        //   })
        // })
        document.querySelectorAll('.search-aside input[name="fuel_type"]').forEach(v => {
          v.addEventListener('change', e => {
            
            setUrlParams('fuel_type', e.target.value, document.querySelector('.search-content').dataset.module);
            // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
          })
        })
        document.querySelectorAll('.search-aside input[name="transmission"]').forEach(v => {
          v.addEventListener('change', e => {
            
            setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside input[name="seats"]').forEach(v => {
          v.addEventListener('change', e => {
            
            setUrlParams('seats', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        document.querySelectorAll('.search-aside input[name="search_type"]').forEach(v => {
          v.addEventListener('change', e => {
            
            setUrlParams('type', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
        if (document.querySelector('.search-filters select[name="order"]')) {
          document.querySelector('.search-filters select[name="order"]').addEventListener('change', e => {
            
            setUrlParams('order', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        }
      }
      document.querySelectorAll('.search-filters [name="term"]').forEach(v => {
        v.addEventListener('change', e => {
          
          setUrlParams('term', e.target.value, document.querySelector('.search-content').dataset.module);
        })
      })
      document.querySelectorAll('.search-filters [name="initial_profile"]').forEach(v => {
        v.addEventListener('change', e => {
          
          setUrlParams('initial_profile', e.target.value, document.querySelector('.search-content').dataset.module);
        })
      })
      document.querySelectorAll('.search-filters [name="mileage"]').forEach(v => {
        v.addEventListener('change', e => {
          
          setUrlParams('mileage', e.target.value, document.querySelector('.search-content').dataset.module);
        })
      })

      if (document.querySelector('.button-clear[data-type="make"]') && selectedMake) {
        document.querySelector('.button-clear[data-type="make"] > span.text-inner').innerText = selectedMake.nextElementSibling.nextElementSibling.textContent;
      }

      if (document.querySelector('.button-clear[data-type="model"]') && document.querySelector('.search-aside input[name="model"]:checked')) {
        document.querySelector('.button-clear[data-type="model"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="model"]:checked').nextElementSibling.nextElementSibling.textContent;
      }

      if (document.querySelector('.button-clear[data-type="van_size"]') && document.querySelector('.search-aside input[name="van_size"]:checked')) {
        document.querySelector('.button-clear[data-type="van_size"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="van_size"]:checked').nextElementSibling.nextElementSibling.textContent;
      }

      document.querySelectorAll('.button-clear').forEach(v => {
        v.addEventListener('click', e => {
          
          setUrlParams(e.target.dataset.type, '', document.querySelector('.search-content').dataset.module);
        })
      })

      // unselectRadio('.search-form input[type=radio]');

    }
  } else {
    if (document.querySelector('#search-bar #search-type')) {
      let selectedMake = document.querySelector('#search-bar [name="make"]').options[document.querySelector('#search-bar [name="make"]').selectedIndex].value;
      // Show Models for selected manufacturer
      if (selectedMake) {
        loadModels(document.querySelector('#search-bar #search-type').value, selectedMake.value);
      }
    }

    // if (document.querySelector('.search-aside') && document.querySelector('.derivative-wrapper')) {
    //   let selectedMake = document.querySelector('.search-aside input[name="make"]:checked');
    //   if (searchButton){
    //     document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
    //       v.addEventListener('change', e => {
    //         selectedMake = document.querySelector('.search-aside input[name="make"]:checked');
    //         document.querySelectorAll('.model-wrapper').forEach(v => { v.innerHTML = ''; v.classList.remove('show'); })
    //         loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);
    //         let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
    //         (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
    //       })
    //     })
    //   }
    //
    //   if (document.querySelector('.search-aside #search-type')) {
    //
    //     // Show Models for selected manufacturer
    //     if (selectedMake) {
    //       loadModelsRadio(document.querySelector('.search-aside #search-type').value, selectedMake.value);
    //
    //       let modelWrapper = selectedMake.parentElement.parentElement.nextElementSibling;
    //       (selectedMake.value == modelWrapper.getAttribute('data-make') ? modelWrapper.classList.add('show') : null);
    //       console.log(".3");
    //     }
    //
    //     if(document.querySelector('.search-aside #body_type-wrapper')){
    //       loadBodyTypesRadio(document.querySelector('.search-aside #search-type').value);
    //     }
    //     if(document.querySelector('.search-aside #fuel_type-wrapper')){
    //       loadFuelTypesRadio(document.querySelector('.search-aside #search-type').value);
    //     }
    //     if(document.querySelector('.search-aside #transmission-wrapper')){
    //       loadTransmissionTypesRadio(document.querySelector('.search-aside #search-type').value);
    //     }
    //
    //     (document.querySelector('.button-clear')) ? null : document.querySelector('.clear-filters').classList.add('visuallyhidden');
    //
    //     if(!searchButton) {
    //       document.querySelectorAll('.search-aside [name="make"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           
    //           document.querySelector('.search-aside .model-wrapper [name="model"]:checked') ? document.querySelector('.search-aside .model-wrapper.show [name="model"]:checked').checked = false : null;
    //           setUrlParams('make', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside [name="model"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           
    //           setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside [name="van_size"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           
    //           //remove bodytype
    //           document.querySelector('.search-aside [name="body_type"]:checked') ? document.querySelector('.search-aside [name="body_type"]:checked').checked = false : null;
    //           setUrlParams('van_size', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside [name="body_type"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           
    //           //remove van size
    //           document.querySelector('.search-aside [name="van_size"]:checked') ? document.querySelector('.search-aside [name="van_size"]:checked').checked = false : null;
    //           setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
    //           // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
    //         })
    //       })
    //       // document.querySelectorAll('.search-aside input[name="budget"]').forEach(v => {
    //       //   v.addEventListener('change', e => {
    //       //     
    //       //     setUrlParams('budget', e.target.value, document.querySelector('.search-content').dataset.module);
    //       //   })
    //       // })
    //       document.querySelectorAll('.search-aside input[name="fuel_type"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           
    //           setUrlParams('fuel_type', e.target.value, document.querySelector('.search-content').dataset.module);
    //           // setUrlParams(e.target.dataset.type, ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside input[name="transmission"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           
    //           setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       document.querySelectorAll('.search-aside input[name="search_type"]').forEach(v => {
    //         v.addEventListener('change', e => {
    //           
    //           setUrlParams('type', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       })
    //       if (document.querySelector('.search-filters select[name="order"]')) {
    //         document.querySelector('.search-filters select[name="order"]').addEventListener('change', e => {
    //           
    //           setUrlParams('order', e.target.value, document.querySelector('.search-content').dataset.module);
    //         })
    //       }
    //     }
    //     document.querySelectorAll('.search-filters [name="term"]').forEach(v => {
    //       v.addEventListener('change', e => {
    //         
    //         setUrlParams('term', e.target.value, document.querySelector('.search-content').dataset.module);
    //       })
    //     })
    //     document.querySelectorAll('.search-filters [name="initial_profile"]').forEach(v => {
    //       v.addEventListener('change', e => {
    //         
    //         setUrlParams('initial_profile', e.target.value, document.querySelector('.search-content').dataset.module);
    //       })
    //     })
    //     document.querySelectorAll('.search-filters [name="mileage"]').forEach(v => {
    //       v.addEventListener('change', e => {
    //         
    //         setUrlParams('mileage', e.target.value, document.querySelector('.search-content').dataset.module);
    //       })
    //     })
    //
    //     if (document.querySelector('.button-clear[data-type="make"]') && selectedMake) {
    //       document.querySelector('.button-clear[data-type="make"] > span.text-inner').innerText = selectedMake.nextElementSibling.nextElementSibling.textContent;
    //     }
    //
    //     if (document.querySelector('.button-clear[data-type="model"]') && document.querySelector('.search-aside input[name="model"]:checked')) {
    //       document.querySelector('.button-clear[data-type="model"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="model"]:checked').nextElementSibling.nextElementSibling.textContent;
    //     }
    //
    //     if (document.querySelector('.button-clear[data-type="van_size"]') && document.querySelector('.search-aside input[name="van_size"]:checked')) {
    //       document.querySelector('.button-clear[data-type="van_size"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="van_size"]:checked').nextElementSibling.nextElementSibling.textContent;
    //     }
    //
    //     document.querySelectorAll('.button-clear').forEach(v => {
    //       v.addEventListener('click', e => {
    //         
    //         setUrlParams(e.target.dataset.type, '', document.querySelector('.search-content').dataset.module);
    //       })
    //     })
    //
    //     // unselectRadio('.search-form input[type=radio]');
    //
    //   }
    // }
  }
}

function unselectRadio(groupSelector) {
  let currentId;
  document.querySelectorAll(groupSelector).forEach((elem) => {
    elem.addEventListener('click', allowUncheck);
    // needed if elem is already pre-checked
    if (elem.checked) {
      currentId = elem.id;
    }
  });

  function allowUncheck(e) {
    if (this.id === currentId) {
      this.checked = false;
      currentId = undefined;
      if (!searchButton) {
        
        setUrlParams(e.target.dataset.type, e.target.value, document.querySelector('.search-content').dataset.module);
      }
    } else {
      currentId = this.id;
    }
  }
}

//END Search Sidebar

/**
  * SEARCH
  */
function searchType(elem, searchType) {
  var hiddenField, searchTab;

  //set hidden field value
  hiddenField = document.getElementById("search-type");
  hiddenField.setAttribute('value', searchType);

  //change header text
  let headerSpan = document.getElementsByClassName("header-span");
  for (let i = 0; i < headerSpan.length; i++) {
    (searchType === 'car') ? headerSpan[i].innerHTML = 'Car Lease' : headerSpan[i].innerHTML = 'Van Lease';
  }

  //remove active class
  searchTab = document.getElementsByClassName("search-tab");
  for (i = 0; i < searchTab.length; i++) {
    searchTab[i].className = searchTab[i].className.replace(" active", "");
  }

  //add active class to clicked
  elem.classList.toggle("active");

  if (document.querySelector('.search-aside')) {
    setUrlParams('type', searchType, document.querySelector('.search-content').dataset.module);
  } else {
    loadManufacturers(document.querySelector('#search-type').value);
    loadBodyTypes(document.querySelector('#search-type').value);
  }

  var dropdown = document.getElementsByName('model')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Model';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;
}

function loadManufacturers($type) {
  var make_dropdowns = document.getElementsByName("make");
  for (i = 0; i < make_dropdowns.length; i++) {

    var dropdown = make_dropdowns[0];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Any Make';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    var url = '/api/'+$type+'/manufacturers/available';

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
          let option = document.createElement('option');
          option.text = data[keysSorted[x]];
          option.value = keysSorted[x];
          dropdown.add(option);
      }
    }).catch(function(err) {
        console.error('Fetch Error -', err);
    });
  }
}

function loadManufacturersRadio($type) {
  const wrapper = document.querySelector(`#make-wrapper > .accordion-scroll-inner`);
  if (wrapper && $type) {
    let url = '/api/'+$type+'/manufacturers/available';

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '?specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '?stock=true';
      }
    }

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let text = data[keysSorted[x]];
        let value = keysSorted[x];
        let modelWrapper = document.createElement("div");
        modelWrapper.classList.add('model-wrapper');
        modelWrapper.setAttribute('id', `model-wrapper--${value}`);
        modelWrapper.setAttribute('data-make', `${value}`);
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedMake = new URLSearchParams(window.location.search).get('make');
        let selectedType = new URLSearchParams(window.location.search).get('search_type');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text.replaceAll(' ', '-').toLowerCase());
        input.setAttribute('name', 'make');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        ((value == selectedMake) && ($type == selectedType)) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text.replaceAll(' ', '-').toLowerCase());
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-round');
        wrapper.appendChild(label);
        wrapper.appendChild(modelWrapper);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = text;
      }
      if(!searchButton) {
        document.querySelectorAll('.search-aside input[name="make"]').forEach(v => {
          v.addEventListener('change', e => {
            setUrlParams('make', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
      }
      if (document.querySelector('.button-clear[data-type="make"]') && document.querySelector('.search-aside input[name="make"]:checked')) {
        document.querySelector('.button-clear[data-type="make"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="make"]:checked').id.toUpperCase();
      }
      loadSearchTriggers();
    }).catch(function(err) {
      wrapper.innerHTML = 'Please select a manufacturer';
      console.error('Fetch Error -', err);
    });
  }
}

function loadModels($type, $manufacturer) {
  var model_dropdowns = document.getElementsByName("model");
  for (let i = 0; i < model_dropdowns.length; i++) {
    var dropdown = model_dropdowns[i];
    dropdown.length = 0;

    var defaultOption = document.createElement('option');
    defaultOption.text = 'Any Model';
    defaultOption.value = '';

    dropdown.add(defaultOption);
    dropdown.selectedIndex = 0;

    const type = document.querySelector('#search-type').value;

    var url = '/api/'+type+'/models/'+$manufacturer+'/available';

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
          response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let option = document.createElement('option');
        option.text = data[keysSorted[x]];
        option.value = keysSorted[x];
        dropdown.add(option);
      }
    }).catch(function(err) {
        console.error('Fetch Error -', err);
    });
  }

}

function loadModelsRadio($type, $manufacturer) {
  const wrapper = document.querySelector(`#model-wrapper--${$manufacturer}`);
  if (wrapper && $type && $manufacturer) {

    let url = '/api/'+$type+'/models/'+$manufacturer+'/available';

    if(typeof love_electric_view != "undefined") {
      url = '/api/used-evs/models/' + $manufacturer;
    }

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '?specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '?stock=true';
      }
    }

    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' +
            response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let text = data[keysSorted[x]];
        let value = keysSorted[x];
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedModel = new URLSearchParams(window.location.search).get('model');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text.replaceAll(' ', '-').toLowerCase());
        input.setAttribute('name', 'model');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (value == selectedModel) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text.replaceAll(' ', '-').toLowerCase());
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-round');
        wrapper.appendChild(label);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = text;
      }
      if(!searchButton) {
        document.querySelectorAll('.search-aside input[name="model"]').forEach(v => {
          v.addEventListener('change', e => {
            
            setUrlParams('model', e.target.value, document.querySelector('.search-content').dataset.module);
          })
        })
      }
      if (document.querySelector('.button-clear[data-type="model"]') && document.querySelector('.search-aside input[name="model"]:checked')) {
        document.querySelector('.button-clear[data-type="model"] > span.text-inner').innerText = document.querySelector('.search-aside input[name="model"]:checked').id.toUpperCase();
      }
    }).catch(function(err) {
      wrapper.innerHTML = 'Please select a manufacturer';
      console.error('Fetch Error -', err);
    });
  }
}

function loadSpecs($type, $model) {
  var dropdown = document.getElementsByName('spec')[0];
  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Spec';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  var url = '/api/'+$type+'/specs/'+$model;

  fetch(url).then(function(response) {
    if (response.status !== 200) {
      console.warn('Looks like there was a problem. Status Code: ' +
        response.status);
      return;
    }
    return response.json();
  }).then(function(data) {
    let keysSorted = Object.keys(data).sort(function(a, b) {
      return data[a].localeCompare(data[b])
    });
    for (let x in keysSorted) {
      let option = document.createElement('option');
      option.text = data[keysSorted[x]];
      option.value = keysSorted[x];
      dropdown.add(option);
    }
  }).catch(function(err) {
      console.error('Fetch Error -', err);
  });

}

function loadBodyTypes($type) {
  var dropdown = document.getElementsByName('body_type')[0];

  if(typeof dropdown == 'undefined'){
    return false;
  }

  dropdown.length = 0;

  var defaultOption = document.createElement('option');
  defaultOption.text = 'Any Bodytype';
  defaultOption.value = '';

  dropdown.add(defaultOption);
  dropdown.selectedIndex = 0;

  var url = '/api/'+$type+'/types?available';

  fetch(url).then(function(response) {
    if (response.status !== 200) {
      console.warn('Looks like there was a problem. Status Code: ' +
        response.status);
      return;
    }
    return response.json();
  }).then(function(data) {
    let keysSorted = Object.keys(data).sort(function(a, b) {
      return data[a].localeCompare(data[b])
    });
    for (let x in keysSorted) {
      let option = document.createElement('option');
      option.text = data[keysSorted[x]];
      option.value = keysSorted[x];
      dropdown.add(option);
    }
  }).catch(function(err) {
      console.error('Fetch Error -', err);
  });
}

function loadBodyTypesRadio($type) {
  const wrapper = document.querySelector('#body_type-wrapper');
  if (wrapper && $type) {
    let url = '/api/'+$type+'/types?available';
    url += document.querySelector('.search-form [name="make"]:checked') != null ? '&make='+document.querySelector('.search-form [name="make"]:checked').value : '';
    url += document.querySelector('.search-form [name="model"]:checked') != null ? '&model='+document.querySelector('.search-form [name="model"]:checked').value : '';

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '&specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '&stock=true';
      }
    }

    // console.log('loadBodyTypesCheckbox')
    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      for (let x in keysSorted) {
        let text = data[keysSorted[x]];
        let value = keysSorted[x];
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedBodyType = new URLSearchParams(window.location.search).get('body_type');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text.replaceAll(' ', '-').toLowerCase());
        input.setAttribute('name', 'body_type');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (value == selectedBodyType) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text.replaceAll(' ', '-').toLowerCase());
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-round');
        wrapper.appendChild(label);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = text;
        spanName.innerText = text.replaceAll('4x4', '4x4/SUV');
        spanName.innerText = text.replaceAll('Sports', 'Convertible');
      }

      if (!searchButton) {
        if (document.querySelectorAll('.search-aside input[name="body_type"]')) {
          document.querySelectorAll('.search-aside input[name="body_type"]').forEach(v => {
            v.addEventListener('change', e => {
              
              setUrlParams('body_type', e.target.value, document.querySelector('.search-content').dataset.module);
              // setUrlParams('body_type', ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
            })
          })
        }
      }
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }
}

function loadFuelTypesRadio($type) {
  const wrapper = document.querySelector('#fuel_type-wrapper');
  if (wrapper && $type) {
    let url = '/api/'+$type+'/fuel-types?available';
    url += document.querySelector('.search-form [name="make"]:checked') != null ? '&make='+document.querySelector('.search-form [name="make"]:checked').value : '';
    url += document.querySelector('.search-form [name="model"]:checked') != null ? '&model='+document.querySelector('.search-form [name="model"]:checked').value : '';
    if (document.querySelector('#body_type-wrapper')) {
      url += document.querySelector('.search-form input[name="body_type"]:checked')!=null ? '&body_type='+document.querySelector('.search-form input[name="body_type"]:checked').value : '';
    } else {
      url += document.querySelector('.search-form [name="body_type"]').value!='' ? '&body_type='+document.querySelector('.search-form [name="body_type"]').value : '';
    }

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '&specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '&stock=true';
      }
      (window.location.pathname === '/electric-leasing' || window.location.pathname === '/van-leasing/electric' || window.location.pathname === '/hybrid-leasing' || window.location.pathname === '/van-leasing/hybrid') ? wrapper.parentElement.classList.add('visuallyhidden') : wrapper.parentElement.classList.remove('visuallyhidden')
    }

    // console.log('loadFuelTypesRadio')
    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      delete data['B'];
      delete data['R'];
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      keysSorted.unshift('Any');
      for (let x in keysSorted) {
        let text = (keysSorted[x]=='Any') ? keysSorted[x] : data[keysSorted[x]].replace(" ","-");
        let value = (keysSorted[x]=='Any') ? '' : keysSorted[x].replace(" ","-");
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedFuelType = new URLSearchParams(window.location.search).get('fuel_type');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text);
        input.setAttribute('name', 'fuel_type');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (selectedFuelType == value) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text);
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-round');
        wrapper.appendChild(label);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = (keysSorted[x]=='Any') ? 'Any' : text.replace("-"," ");
      }

      if (!searchButton) {
        if(document.querySelectorAll('.search-aside input[name="fuel_type"]')){
          document.querySelectorAll('.search-aside input[name="fuel_type"]').forEach(v => {
            v.addEventListener('change', e => {
              
              setUrlParams('fuel_type', e.target.value, document.querySelector('.search-content').dataset.module);
              // setUrlParams('fuel_type', ((e.target.dataset.multiple) ? e.target.value : ''), document.querySelector('.search-content').dataset.module, e.target.dataset.multiple);
            })
          })
        }
      }
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }
}

function loadTransmissionTypesRadio($type) {
  const wrapper = document.querySelector('#transmission-wrapper');
  if (wrapper && $type) {
    let url = '/api/'+$type+'/transmissions?available';
    url += document.querySelector('.search-form [name="make"]:checked') != null ? '&make='+document.querySelector('.search-form [name="make"]:checked').value : '';
    url += document.querySelector('.search-form [name="model"]:checked') != null ? '&model='+document.querySelector('.search-form [name="model"]:checked').value : '';
    if (document.querySelector('#body_type-wrapper')) {
      url += document.querySelector('.search-form input[name="body_type"]:checked')!=null ? '&body_type='+document.querySelector('.search-form input[name="body_type"]:checked').value : '';
    } else {
      url += document.querySelector('.search-form [name="body_type"]').value!='' ? '&body_type='+document.querySelector('.search-form [name="body_type"]').value : '';
    }

    if(document.querySelector('form.search-form')){
      if(window.location.pathname.includes('/special-offers') || window.location.search.includes('offers=specials')){
        url += '&specials=true';
      }
      if(window.location.pathname.includes('/stock') || window.location.search.includes('offers=stock')){
        url += '&stock=true';
      }
    }

    // console.log('loadTransmissionTypesRadio')
    fetch(url).then(function(response) {
      if (response.status !== 200) {
        console.warn('Looks like there was a problem. Status Code: ' + response.status);
        return;
      }
      return response.json();
    }).then(function(data) {
      wrapper.innerHTML = '';
      let keysSorted = Object.keys(data).sort(function(a, b) {
        return data[a].localeCompare(data[b])
      });
      // keysSorted.unshift('Any');
      for (let x in keysSorted) {
        let text = (keysSorted[x]=='Any') ? keysSorted[x] : data[keysSorted[x]];
        let value = keysSorted[x];
        value = (value === 'Automatic') ? 'A' : (value === 'Manual') ? 'M' : (value === 'Any') ? '' : value;
        let input = document.createElement("input");
        let label = document.createElement("label");
        let spanLabelWrapper = document.createElement("span");
        let spanCheckmark = document.createElement("span");
        let spanName = document.createElement("span");
        let selectedTransmissionType = new URLSearchParams(window.location.search).get('transmission');
        input.setAttribute('type', 'radio');
        input.setAttribute('id', text);
        input.setAttribute('name', 'transmission');
        input.setAttribute('value', value);
        input.classList.add('form-control', 'radio-css');
        (value == selectedTransmissionType) ? input.setAttribute('checked', 'true') : null;
        label.setAttribute('for', text);
        label.classList.add('checkbox-label');
        spanCheckmark.classList.add('checkmark');
        spanCheckmark.classList.add('checkmark-round');
        wrapper.appendChild(label);
        label.appendChild(spanLabelWrapper);
        spanLabelWrapper.appendChild(input);
        spanLabelWrapper.appendChild(spanCheckmark);
        spanLabelWrapper.appendChild(spanName);
        spanName.innerText = text;
      }

      if (!searchButton) {
        if(document.querySelectorAll('.search-aside input[name="transmission"]')){
          document.querySelectorAll('.search-aside input[name="transmission"]').forEach(v => {
            v.addEventListener('change', e => {
              
              setUrlParams('transmission', e.target.value, document.querySelector('.search-content').dataset.module);
            })
          })
        }
      }
    }).catch(function(err) {
      console.error('Fetch Error -', err);
    });
  }
}

// Search Budget slider
function loadBudgetSlider() {
  const budgetSlider = document.querySelector('#budget-slider');
  const updateResultsBtn = document.getElementById('update-results-btn');
  const budgetHiddenField = document.querySelector('input[name="budget"]');
  if(budgetSlider && updateResultsBtn){
    let initial_min = parseInt(budgetSlider.dataset.min);
    let initial_max = parseInt(budgetSlider.dataset.max);
    let updateSliderValue;

    if (budgetSlider.querySelector('.noUi-base')) {
      budgetSlider.classList = 'sliderContainer';
      budgetSlider.querySelector('.noUi-base').remove();
      delete budgetSlider.noUiSlider;
    }

    noUiSlider.create(budgetSlider, {
      start: [initial_min, initial_max],
      step: 100,
      margin: 100,
      behaviour: 'drag',
      connect: true,
      range: {
        min: 0,
        max: 1000
      },
      format: {
        to: function(value) {
          if (value === 1000) {
            return 'No Max';
          }
          return value;
        },
        from: function(value) {
          if (value === 'No Max') {
            return 1000;
          }
          return value;
        }
      }
    });
    updateSliderValue = function(slider, handle = 0) {
      let children, i, results, val, values;
      children = slider.getElementsByClassName('noUi-handle');
      values = slider.noUiSlider.get();
      i = 0;
      results = [];
      while (i < children.length) {
        if (children.length === 1) {
          val = parseInt(values);
        } else {
          val = parseInt(values[i]);
        }
        if(val == 1000){
          val = 'No Max';
        }
        children[i].dataset.value = val;
        results.push(i++);
      }
      return results;
    };
    budgetSlider.noUiSlider.on('update', function() {
      const selectedValues = budgetSlider.noUiSlider.get();
      let updated_min = parseInt(selectedValues[0]);
      let updated_max = parseInt(selectedValues[1]);

      if(isNaN(updated_max)){
        updated_max = 1000;
      }

      if (updated_max == 1000) {
        budgetHiddenField ? budgetHiddenField.value = `${updated_min}+` : null;
      } else {
        budgetHiddenField ? budgetHiddenField.value = `${updated_min}-${updated_max}` : null;
      }

      if (!searchButton) {
        if(document.querySelector('.mobile-accordion[data-field="budget"]').classList.contains('active')){
          if (initial_min != updated_min || initial_max != updated_max) {
            updateResultsBtn.classList.add('slider-moved')
          } else {
            updateResultsBtn.classList.remove('slider-moved')
          }
        }
      }

      if(updated_max - updated_min < 200 && updated_max - updated_min > 0){
        document.querySelector('#budget-slider .noUi-handle-lower').classList.add('min-handle');
        document.querySelector('#budget-slider .noUi-handle-upper').classList.add('max-handle');
      } else{
        document.querySelector('#budget-slider .noUi-handle-lower').classList.remove('min-handle');
        document.querySelector('#budget-slider .noUi-handle-upper').classList.remove('max-handle');
      }

      if(updated_max == 1000){
        document.querySelector('#budget-slider .noUi-handle-upper').classList.add('no-max');
      } else{
        document.querySelector('#budget-slider .noUi-handle-upper').classList.remove('no-max');
      }

      return updateSliderValue(budgetSlider);
    });

    updateResultsBtn.addEventListener('click', function(e){
      e.preventDefault();

      // Get the selected values from the slider
      const selectedValues = budgetSlider.noUiSlider.get();
      let minValue = parseInt(selectedValues[0]);
      let maxValue = parseInt(selectedValues[1]);


      if(isNaN(maxValue)){
        setUrlParams('budget', minValue + '+', document.querySelector('.search-content').dataset.module);
      } else{
        setUrlParams('budget', minValue + '-' + maxValue, document.querySelector('.search-content').dataset.module);
      }
    });

  }
}
// END SEARCH

document.addEventListener('DOMContentLoaded', () => {
  // Pagination
  document.querySelectorAll('.pagination-holder .results-per-page select option')?.forEach(v => { (v.innerHTML = v.innerHTML.replace('Show', '<span>Results Per Page:</span>')) })
  document.querySelector('.pagination-holder .results-per-page select option[value="All"]')?.setAttribute('value', '9999')
  let url = new URL(document.URL);
  url.searchParams.has('show') ? (url.searchParams.get('show') === '9999' ? document.querySelector('.pagination-holder .results-per-page select').selectedIndex = 6 : null) : null;

  document.querySelector('.pagination-holder .results-per-page select')?.addEventListener('change', ev => {
    url.searchParams.set('show', (ev.target.value === 'All') ? '9999' : ev.target.value);
    url.searchParams.has('page') ? url.searchParams.delete('page') : null;
    window.location.href = url;
  })
  // END Pagination


  // Contact Form
  if(document.getElementById('send-contact-form')){
    // Do captcha and submit form

    let button = document.querySelector('#send-contact-form');
    let terms_1 = document.querySelector('#contact-form [name=consent]');
    terms_1.onchange = function() {
      button.disabled = !this.checked;
    };

    document.getElementById('send-contact-form').addEventListener("click", function(e) {
      e.preventDefault();

      document.body.classList.remove('loaded');

      button.disabled = true;
      button.innerHTML = 'Sending...';

      grecaptcha.ready(function() {
        grecaptcha.execute(document.getElementById('contact-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
          document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

          let url = '/contact';
          let email = document.querySelector('#contact-form [name=email]').value;
          let name = document.querySelector('#contact-form [name=name]').value;
          /*let forename = document.querySelector('#contact-form [name=name]').value;
          let surname = document.querySelector('#contact-form [name=surname]').value;*/
          let company = '';
          if (document.querySelector('#contact-form [name=company]')){
            company = document.querySelector('#contact-form [name=company]').value;
          }
          let telephone = document.querySelector('#contact-form [name=telephone]').value;
          let comments = document.querySelector('#contact-form [name=comments]').value;
          let csrf_token = document.querySelector('#contact-form [name=_token]').value;

          fetch(url, {
            method: 'POST',
            body: JSON.stringify({
              'type': 'General Enquiry',
              'name': name,
              /*'name': forename + ' ' + surname,
              'forename': forename,
              'surname': surname,*/
              'company': company,
              'email': email,
              'telephone': telephone,
              'comments': comments,
              '_token': csrf_token,
              'g-recaptcha-response': recaptcha_token
            }),
            headers:{
              'Content-Type': 'application/json'
            }}).then(function(response) {
            document.body.classList.add('loaded');
            button.disabled = false;
            button.innerHTML = 'Submit Enquiry';
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' +
                  response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            if(data.status !== 'ok'){
              let errors = '';
              for (var i in data.errors) {
                errors += data.errors[i][0]+'\n';
              }
              button.disabled = false;
              button.innerHTML = 'Submit Enquiry';
              return alert('There was a problem with your form\n\n'+errors);
            }

            button.disabled = false;
            button.innerHTML = 'Submit Enquiry';
            document.getElementsByClassName('contact-form')[0].reset();
            document.getElementsByClassName('contact-content')[0].classList.add('hidden');
            // document.getElementsByClassName('contact-form-header')[0].classList.add('hidden');
            document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
            document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

            // Trigger event tracking
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'General Enquiry Received'
            });


          }).catch(function(err) {
            document.body.classList.add('loaded');
            console.error('Fetch Error -', err);
            return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
          });

        });
      });

    });
  }
  // END Contact Form

  // Refer A Friend Form
  if(document.getElementById('send-referral-form')){
    // Do captcha and submit form

    let button = document.querySelector('#send-referral-form');
    let terms_2 = document.querySelector('#referral-form [name=consent]');
    terms_2.onchange = function() {
      button.disabled = !this.checked;
    };

    document.getElementById('send-referral-form').addEventListener("click", function(e) {
      e.preventDefault();
      document.body.classList.remove('loaded');

      button.disabled = true;
      button.innerHTML = 'Sending...';

      grecaptcha.ready(function() {
        grecaptcha.execute(document.getElementById('referral-form').dataset['recaptcha'], {action: 'contact'}).then(function(recaptcha_token) {
          document.querySelector('input[name=g-recaptcha-response]').value = recaptcha_token;

          let url = '/contact';
          let email = document.querySelector('#referral-form [name=email]').value;
          let forename = document.querySelector('#referral-form [name=name]').value;
          let surname = document.querySelector('#referral-form [name=surname]').value;
          let company = '';
          if (document.querySelector('#referral-form [name=company]')){
            company = document.querySelector('#referral-form [name=company]').value;
          }
          let telephone = document.querySelector('#referral-form [name=telephone]').value;

          let comments = '';
          if (document.querySelector('#referral-form [name=referral-name]')) {
            comments = 'Referral First Name: ' + document.querySelector('#referral-form [name=referral-name]').value +
                (document.querySelector('#referral-form [name=referral-surname]') ? '\n\r Referral Surname: ' +
                    document.querySelector('#referral-form [name=referral-surname]').value : '') +
                (document.querySelector('#referral-form [name=referral-email]') ? '\n\r Referral Email: ' +
                    document.querySelector('#referral-form [name=referral-email]').value : '') +
                (document.querySelector('#referral-form [name=referral-telephone]') ? '\n\r Referral Phone: ' +
                    document.querySelector('#referral-form [name=referral-telephone]').value : '');
          }

          let csrf_token = document.querySelector('#referral-form [name=_token]').value;

          fetch(url, {
            method: 'POST',
            body: JSON.stringify({
              'type': 'Referral Form',
              'name': forename + ' ' + surname,
              'forename': forename,
              'surname': surname,
              'company': company,
              'email': email,
              'telephone': telephone,
              'comments': comments,
              '_token': csrf_token,
              'g-recaptcha-response': recaptcha_token
            }),
            headers:{
              'Content-Type': 'application/json'
            }}).then(function(response) {
            document.body.classList.add('loaded');
            button.disabled = false;
            button.innerHTML = 'Send Referral';
            if (response.status !== 200) {
              console.warn('Looks like there was a problem. Status Code: ' +
                  response.status);
              return;
            }
            return response.json();
          }).then(function(data) {
            if(data.status !== 'ok'){
              let errors = '';
              for (var i in data.errors) {
                errors += data.errors[i][0]+'\n';
              }
              button.disabled = false;
              button.innerHTML = 'Send Referral';
              return alert('There was a problem with your form\n\n'+errors);
            }

            button.disabled = false;
            button.innerHTML = 'Send Referral';
            document.getElementsByClassName('contact-form')[0].reset();
            document.getElementsByClassName('contact-content')[0].classList.add('hidden');
            // document.getElementsByClassName('contact-form-header')[0].classList.add('hidden');
            document.getElementsByClassName('thank-you')[0].classList.remove('hidden');
            document.getElementsByClassName('contact-details-form')[0].scrollIntoView();

            // Trigger event tracking
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
              'event': 'General Enquiry Received'
            });


          }).catch(function(err) {
            document.body.classList.add('loaded');
            console.error('Fetch Error -', err);
            return alert('There was a problem sending your enquiry. Please call us or use our general contact email address.');
          });

        });
      });

    });
  }
  // END Refer A Friend Form

})



// Helper to submit the newsletter form
function submitNewsletterForm(url, name, email, token, formClass, successMessage, cookieExpiry, dataLayerEvent) {
  fetch(url, {
    method: 'POST',
    body: JSON.stringify({ 'name': name, 'first_name': name, 'email': email, '_token': token }),
    headers: { 'Content-Type': 'application/json' }
  }).then(response => {
    if (response.status !== 200) {
      console.warn('Looks like there was a problem. Status Code: ' + response.status);
      return;
    }
    return response.json();
  }).then(data => {
    if (data.status !== 'ok') {
      let errors = Object.values(data.errors).map(err => err[0]).join('\n');
      return alert('There was a problem with your sign-up details\n\n' + errors);
    }

    document.getElementsByClassName(formClass)[0].reset();
    alert(successMessage);

    writeCookie('newsletter_dismissed', 'true', cookieExpiry);

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({ 'event': dataLayerEvent });
  }).catch(err => console.error('Fetch Error -', err));
}

// Function to check cookie and show/hide the popup
function handleNewsletterPopup() {
  const newsletterPopup = document.querySelector('#newsletter-popup');
  if (!newsletterPopup) {
    console.log('No newsletter popup found');
    return;
  }

  const dismissed = readCookie('newsletter_dismissed');
  console.log('Cookie checked:', dismissed);
  if (!dismissed) {
    setTimeout(() => {
      document.body.classList.add('show-newsletter');
      console.log('Popup shown');
    }, parseInt(newsletterPopup.dataset.delay));
  } else {
    console.log('Popup dismissed, not showing again');
  }

  document.querySelector('#newsletter-close').addEventListener('click', () => {
    document.body.classList.remove('show-newsletter');
    setTimeout(() => {
      newsletterPopup.classList.add('dismissed');
      console.log('Popup dismissed by user');
    }, 1000);

    writeCookie('newsletter_dismissed', 'true', newsletterPopup.dataset.expiry);
  });

  // Email signup form logic
  document.getElementById('email-signup-popup').addEventListener('click', (e) => {
    e.preventDefault();
    const url = '/newsletter';
    const email = document.getElementById('newsletter-email-popup').value;
    const name = document.getElementById('newsletter-name-popup').value;
    const token = document.getElementsByName('_token')[0].value;

    submitNewsletterForm(url, name, email, token, 'newsletter-form-popup', 'Thank you!', newsletterPopup.dataset.expiry, 'Newsletter Form Submit');
  });
}

// General newsletter form submission handler
function initializeFormSubmissionHandlers() {
  const forms = [
    { formId: 'email-signup', emailId: 'newsletter-email', nameId: 'newsletter-name', formClass: 'newsletter-form', cookieExpiry: 7 },
    { formId: 'email-signup-blog', emailId: 'newsletter-email-blog', nameId: 'newsletter-name-blog', formClass: 'newsletter-form-blog', cookieExpiry: 7 }
  ];

  forms.forEach(({ formId, emailId, nameId, formClass, cookieExpiry }) => {
    const formButton = document.getElementById(formId);
    if (formButton) {
      formButton.addEventListener('click', e => {
        e.preventDefault();
        const url = '/newsletter';
        const email = document.getElementById(emailId).value;
        const name = document.getElementById(nameId).value;
        const token = document.getElementsByName('_token')[0].value;

        submitNewsletterForm(url, name, email, token, formClass, 'Thank you!', cookieExpiry, 'Newsletter Form Submit');
      });
    }
  });
}

// Initialize popup and form handlers
document.addEventListener('DOMContentLoaded', () => {
  handleNewsletterPopup();
  initializeFormSubmissionHandlers();
});



//Lazy Load Images
document.addEventListener("DOMContentLoaded", function() {
  let lazyImages = [].slice.call(document.querySelectorAll("img.lazy"));
  let active = false;

  const lazyLoad = function() {
    if (active === false) {
      active = true;

      lazyImages.forEach(function(lazyImage) {
        if ((lazyImage.getBoundingClientRect().top <= window.innerHeight && lazyImage.getBoundingClientRect().bottom >= 0) && getComputedStyle(lazyImage).display !== "none") {
          lazyImage.src = lazyImage.dataset.src;
          // lazyImage.srcset = lazyImage.dataset.srcset;
          lazyImage.classList.remove("lazy");

          lazyImages = lazyImages.filter(function(image) {
            return image !== lazyImage;
          });

          if (lazyImages.length === 0) {
            document.removeEventListener("scroll", lazyLoad);
            window.removeEventListener("resize", lazyLoad);
            window.removeEventListener("orientationchange", lazyLoad);
          }
        }
      });

      active = false;
    }
  };

  document.addEventListener("scroll", lazyLoad);
  window.addEventListener("resize", lazyLoad);
  window.addEventListener("orientationchange", lazyLoad);
  lazyLoad();
});

/*function loadSearchForm () {
  // Load Search Form
  if(document.getElementsByClassName('search-form').length>0){
    // Search
    let searchType = document.querySelector('#search-type').value;

    loadManufacturers(searchType);

    document.querySelector('.search-form [name=make]').addEventListener("change", function(e){
      loadModels(document.querySelector('#search-type').value, e.target.value);
    });
  }
}*/

function loadSearchForm () {
  // Load Search Form
  if(document.getElementsByClassName('search-form').length>0){
    loadBudgetSlider();
    updateSearchToggles();
    loadSearchTriggers();
    loadSearchType();
    // Search
    let searchType = document.querySelector('#search-type') ? document.querySelector('#search-type').value : 'car';
    if (document.querySelector('#search-bar')) {
      loadManufacturers(searchType);
      loadBodyTypes(searchType);
    } else {
      // loadManufacturersRadio(searchType);
      loadBodyTypesRadio(searchType);
    }
    document.querySelectorAll('.search-form [name=search-type]').forEach(v => { v.addEventListener("change", function(e){
      if (document.querySelector('#search-bar')) {
        loadManufacturers(searchType, e.target.value);
      } else {
        loadManufacturersRadio(searchType, e.target.value);
        loadBodyTypesRadio(searchType, e.target.value);
      }
    })
    });

    document.querySelectorAll('.search-form [name=make]').forEach(v => { v.addEventListener("change", function(e){
      if (document.querySelector('#search-bar')) {
        if (document.querySelector('[name="fuel_type"]')) {
          loadModels(searchType, e.target.value, true);
        } else {
          loadModels(searchType, e.target.value);
        }
      } else {
        loadModelsRadio(searchType, e.target.value);
        console.log(e.target.value)
        console.log(searchType)
      }
    })
    });
  }
}

setTimeout(function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
}, 2000);
document.addEventListener("DOMContentLoaded", function() {
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader

    // Load Search Form
    loadSearchForm();
    // END Load Search Form
});
document.onload = (function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader
});
window.onload = (function(){
  // Preloader
  document.querySelector('html').classList.add("site-loaded");
  document.body.classList.add("loaded");
  // END Preloader

  // // Load Sidebar Search
  // if (document.getElementsByClassName('search-aside').length > 0) {
  //   updateSearchToggles();
  //   loadSearchTriggers();
  // }

  // Search Sidebar Toggle
  let sidebarToggle = document.querySelector('#search-filters-toggle');
  if (sidebarToggle) {
    sidebarToggle.addEventListener('click', (e) => {
      if (!sidebarToggle.parentElement.classList.contains('active')) {
        setTimeout(() => {
          document.querySelector('body').scrollIntoView();
          console.log(document.querySelector('#search-filters-toggle').parentElement.parentElement)
        }, 500);
        // document.querySelector('.search-content').style.minHeight = `${(document.querySelector('.search-results-form').clientHeight) * 2}px`;
      } else {
        e.preventDefault();
        // document.querySelector('.search-content').style.minHeight = `100px`;
      }
      sidebarToggle.parentElement.classList.toggle('active');
      sidebarToggle.blur();
      sidebarToggle.parentElement.focus();
    })
  }
  // END Search Sidebar Toggle

  // Search Mobile Popup
  const filterButton = document.querySelector('.search-filters-mobile .vehicle-filters');
  const termsButton = document.querySelector('.search-filters-mobile .vehicle-terms');
  let searchSidebar = document.querySelector('.search-aside');
  let searchTerms = document.querySelector('.search-filters');
  // const updateMobileResultsBtn = document.querySelector('.update-mobile-results');
  let modelSelected = 0;
  let specSelected = 0;

  if(filterButton && searchSidebar){
    const modalMobileFilters = new tingle.modal({
      footer: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: ['mobile-sidebar'],
      beforeOpen: function () {
        // modelSelected = document.querySelector('.search-aside select[name="model"]').selectedIndex
        // specSelected = document.querySelector('.search-aside select[name="spec_level"]').selectedIndex
        searchSidebar ? modalMobileFilters.setContent(searchSidebar.outerHTML) : null;
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.remove('visuallyhidden') : null;
      },
      onOpen: function () {
        let searchAside = document.querySelector('.search-content .search-aside');
        searchAside.remove();
        // let headerHeight = updateMobileResultsBtn.offsetHeight;
        // document.querySelector('.mobile-sidebar.tingle-modal').setAttribute('style', `margin-bottom:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
        // loadSearchTriggers();
        // updateSearchToggles();
        loadSearchForm();
        loadSearchType();
        // loadUrlParams();
        // resetSearch()
        // document.querySelector('.search-aside select[name="model"]').selectedIndex = modelSelected;
        // document.querySelector('.search-aside select[name="spec_level"]').selectedIndex = specSelected;
        // updateMobileResults();
        setTimeout(() => { toggleAccordions(); }, 1000);
      },
      onClose: function() {
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.add('visuallyhidden') : null;
        filterButton.parentElement.classList.remove('is-active');
        let searchTingle = document.querySelector('.tingle-modal-box__content .search-aside');
        document.querySelector('.search-content').prepend(searchTingle);
        // loadSearchTriggers();
        // updateSearchToggles();
        loadSearchForm();
        loadSearchType();
        // loadUrlParams();
        // resetSearch()
        // updateMobileResults();
        setTimeout(() => { toggleAccordions(); }, 500);
      }
    });

    filterButton.addEventListener("click", function(e){
      filterButton.parentElement.classList.toggle('is-active');
      if(filterButton.parentElement.classList.contains("is-active")) {
        modalMobileFilters.open();
      } else{
        modalMobileFilters.close();
      }
    })
  }
  if(termsButton && searchTerms){
    const modalMobileTerms = new tingle.modal({
      footer: false,
      closeMethods: ['overlay', 'button', 'escape'],
      cssClass: ['mobile-sidebar-terms'],
      beforeOpen: function () {
        // modelSelected = document.querySelector('.search-aside select[name="model"]').selectedIndex
        // specSelected = document.querySelector('.search-aside select[name="spec_level"]').selectedIndex
        searchTerms ? modalMobileTerms.setContent(searchTerms.outerHTML) : null;
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.remove('visuallyhidden') : null;
      },
      onOpen: function () {
        searchTerms = document.querySelector('.search-filters');
        searchTerms.remove();
        // let headerHeight = updateMobileResultsBtn.offsetHeight;
        // document.querySelector('.mobile-sidebar.tingle-modal').setAttribute('style', `margin-bottom:${headerHeight}px;height:calc(100vh - ${headerHeight}px)!important`);
        // loadSearchTriggers();
        // updateSearchToggles();
        // priceToggles();
        // toggleSwitches();
        // togglePrices();
        // updatePrice();
        loadSearchForm();
        searchSorter();
        loadSearchType();
        // loadUrlParams();
        // document.querySelector('.search-aside select[name="model"]').selectedIndex = modelSelected;
        // document.querySelector('.search-aside select[name="spec_level"]').selectedIndex = specSelected;
        // updateMobileResults();
        setTimeout(() => { toggleAccordions(); }, 1000);
        // resetSearch()
      },
      onClose: function() {
        // updateMobileResultsBtn ? updateMobileResultsBtn.classList.add('visuallyhidden') : null;
        termsButton.parentElement.classList.remove('is-active');
        let searchTingle = document.querySelector('.tingle-modal-box__content .search-filters');
        document.querySelector('.deal-list.deal-boxes').insertAdjacentElement('beforebegin', searchTingle);
        // loadSearchTriggers();
        // updateSearchToggles();
        // priceToggles();
        // toggleSwitches();
        // togglePrices();
        // updatePrice();
        loadSearchForm();
        searchSorter();
        loadSearchType();
        // loadUrlParams();
        // updateMobileResults();
        // resetSearch()
        setTimeout(() => { toggleAccordions(); }, 500);
      }
    });

    termsButton.addEventListener("click", function(e){
      termsButton.parentElement.classList.toggle('is-active');
      if(termsButton.parentElement.classList.contains("is-active")) {
        modalMobileTerms.open();
      } else{
        modalMobileTerms.close();
      }
    })
  }
  // END Search Mobile Popup

  // Show Only Filters
  // let searchToggles = document.querySelectorAll('.search-results .search-filters input');
  // if (searchToggles) {
  //   searchToggles.forEach(value => {
  //     value.addEventListener('change', (e) => {
  //       let searchUrl = new URL(window.location.origin + '/car-leasing');
  //       let vans = (window.location.pathname.includes('van-leasing') || window.location.search.includes('search-type=van')) ? '/van-leasing' : '';
  //       (window.location.pathname.includes('van-leasing')) ? searchUrl = new URL(window.location.origin + '/van-leasing') : null;
  //       (e.target.value === 'special' && e.target.checked) ? searchUrl = new URL(window.location.origin + vans + '/special-offers') : null;
  //       (e.target.value === 'stock' && e.target.checked) ? searchUrl = new URL(window.location.origin + vans + '/stock') : null;
  //       
  //       window.location.href = searchUrl;
  //     })
  //   })
  // }
  // END Show Only Filters

});

document.addEventListener('DOMContentLoaded', () => {

  // Deal Box Slider
  const dealBoxSlider = [].slice.call(document.querySelectorAll('.offers-strip:not(.derivative-page) .offers-strip-ctr'))
  if (dealBoxSlider) {
    dealBoxSlider.forEach((e) => {
      let sliderID = e.parentElement.parentElement.getAttribute('id')
      new Glider(e, {
        slidesToScroll: 1,
        slidesToShow: 1,
        draggable: true,
        scrollLock: true,
        arrows: {
          prev: '.offers-strip#'+sliderID+' .glider-prev',
          next: '.offers-strip#'+sliderID+' .glider-next'
        },
        responsive: [
          {
            breakpoint: 767,
            settings: {
              slidesToShow: 2,
            }
          },
          {
            breakpoint: 1200,
            settings: {
              slidesToShow: 3,
            }
          }
        ]
      })
    })
  }

  // Featured Ranges Slider
  const rangeSlider = document.querySelector('#featured-range-track');
  if (rangeSlider) {
    new Glider(rangeSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      dots: '#featured-ranges-nav'
    })
  }

  // Auto-slide helper function
  function sliderAuto(slider, milliseconds) {
    const slidesCount = slider.track.childElementCount;
    let slideTimeout = null;
    let nextIndex = 1;

    function slide() {
      slideTimeout = setTimeout(
        function () {
          if (nextIndex >= slidesCount ) {
            nextIndex = 0;
          }
          slider.scrollItem(nextIndex++);
        },
        milliseconds
      );
    }

    slider.ele.addEventListener('glider-animated', function() {
      window.clearInterval(slideTimeout);
      slide();
    });

    slide();
  }

  // About Gallery Slider
  const aboutSlider = document.querySelector('#about-gallery');
  if (aboutSlider) {
    const glider = new Glider(aboutSlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      scrollLock: false,
      rewind: true,
      draggable: true,
      responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
        }
      },
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 3,
        }
      }
    ]
    })
    sliderAuto(glider, 3000);
  }

  // Derivative Gallery Slider
  const dealGallerySlider = document.querySelector('.deal-gallery-track');
  if (dealGallerySlider) {
    new Glider(dealGallerySlider, {
      slidesToScroll: 1,
      slidesToShow: 1,
      draggable: true,
      scrollLock: true,
      arrows: {
        prev: '.deal-gallery-controls .glider-prev',
        next: '.deal-gallery-controls .glider-next'
      },
      responsive: [
        {
          breakpoint: 767,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
          }
        },
        {
          breakpoint: 1200,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1280,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1600,
          settings: {
            slidesToShow: 4,
          }
        },
        {
          breakpoint: 1900,
          settings: {
            slidesToShow: 5,
          }
        }
      ]
    })
  }

  // Close modals on orientation changes
  window.addEventListener("orientationchange", function() {
    modalMobileNav.close();
    hamburger.classList.remove('active');
    hamburger.classList.remove('is-active');
    navContainer.classList.remove('is-active');
    navbar.classList.remove('is-sticky')
    tingleModal.classList.remove('is-sticky')
  }, false);

  // Table Sorting
  function sortTable(elem) {
    let sortName = elem.composedPath()[0].dataset.sortname;
    let sortDirection = elem.composedPath()[0].dataset.sortdirection;
    let tableBody = elem.composedPath()[3].childNodes[3];
    let tableRows = Array.from(tableBody.children);

    let sortRows = (dir) => [...tableRows].filter(row => (sortName !== 'price' && row.dataset[sortName].length) || (sortName === 'price' && row.dataset.price !== 'POA')).sort(function (a, b) {
      a = a.dataset[sortName];
      b = b.dataset[sortName];
      return (dir === 'asc') ? b.localeCompare(a) : a.localeCompare(b);
    });

    if (sortDirection.length && sortDirection === 'asc') {
      [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
      elem.composedPath()[0].setAttribute('data-sortdirection', 'desc');
      let sortTable = sortRows('desc').forEach(function (value) {
        value.remove();
        tableBody.prepend(value);
      });
    } else {
      [].slice.call(document.querySelectorAll('.table-sort')).forEach((el) => el.setAttribute('data-sortdirection', ''));
      elem.composedPath()[0].setAttribute('data-sortdirection', 'asc');
      let sortTable = sortRows('asc').forEach(function (value) {
        value.remove();
        tableBody.prepend(value);
      });
    }
  }

  // Sort Model Table
  let sortHeaders = document.querySelectorAll('#model-table .model-table-head .table-sort[data-sortName]');
  [...sortHeaders].forEach((value) => value.addEventListener('click', (val) => sortTable(val)));

});

// Fix first load wrong offset
window.addEventListener("load", function() {
  if (window.location.hash) {
    const el = document.querySelector(window.location.hash);
    if (el) {
      el.scrollIntoView({ behavior: "smooth" });
    }
  }
});
